import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as checkoutWizardActions from 'actions/checkoutWizardActions';
import * as countriesActions from 'actions/countriesActions';

import Wizard from 'components/Wizard';
import SelectPackagePage from 'containers/SelectPackagePage';
import SecureCheckoutPage from 'containers/SecureCheckoutPage';
import { trackPageView } from 'lib/eventTracking';
import { getPreviewUrl } from 'lib/support';

class CheckoutWizardContainer extends Component {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    goToStep: PropTypes.func.isRequired,
    snapSell: PropTypes.bool,
    currentEvent: ImmutablePropTypes.map,
    currentUser: ImmutablePropTypes.map,
    fetchCountries: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  };

  static defaultProps = {
    snapSell: false,
  }

  componentDidMount() {
    trackPageView('Checkout Wizard');
  }

  componentWillMount() {
    this.props.fetchCountries();
    if (this.getSteps().length > 2 && this.props.currentStep === 1) this.props.goToStep(2);
  }

  userHasCredits() {
    const { userLoggedIn, currentUser, pricingTierLevel } = this.props;
    if (!userLoggedIn) return;

    const availablePricingTiers = currentUser.get('available_pricing_tiers');

    if (availablePricingTiers) {
      return pricingTierLevel <= availablePricingTiers.max();
    }
  }

  getSteps() {
    const { currentEvent, currentUser } = this.props;
    let steps = [
      {
        name: this.userHasCredits() ? 'Package' : 'Select Package',
        faIconClass: 'fa fa-cubes',
        component: <SelectPackagePage/>,
        accessible: true,
        completed: this.props.currentStep > 1
      },
      {
        name: this.userHasCredits() ? 'Done!' : 'Secure Checkout',
        faIconClass: 'fa fa-flag',
        component: <SecureCheckoutPage/>,
        accessible: true,
        completed: false
      },
    ];

    if (currentEvent && currentUser) {
      const previewUrl = getPreviewUrl(currentEvent, currentUser);
      steps[0].completed = this.props.currentStep > 2;

      steps.unshift({
        name: 'Plan Your Event',
        accessible: true,
        completed: true,
        back: true,
        onClick: () => window.location = previewUrl,
      });
    }

    return steps;
  }

  changeStep(step) {
    trackPageView(step === (this.getSteps().length - 1) ? 'Checkout' : 'Packages' );

    return this.props.goToStep(step);
  }

  render() {
    const steps = this.getSteps();
    let { currentStep } = this.props;
    const { isPrepay } = this.props;

    if (steps.length > 2 && currentStep === 1 || isPrepay) currentStep = 2;
    if (this.props.snapSell) currentStep = steps.length;

    return (
      <Wizard
        currentStep={currentStep}
        additionalStepProps={{ snapSell: this.props.snapSell }}
        steps={steps}
        onStepChange={this.changeStep.bind(this)}
        history={this.props.history}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  currentStep: state.checkoutWizard.get('currentStep'),
  currentEvent: state.checkoutData.get('current_event'),
  isPrepay: state.checkoutData.get('prepay'),
  currentUser: state.currentUser.get('data'),
  userLoggedIn: state.currentUser.get('isLoggedIn'),
  pricingTierLevel: state.checkoutData.get('pricing_tier_level'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(checkoutWizardActions, dispatch),
  ...bindActionCreators(countriesActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutWizardContainer);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/CheckoutWizardContainer.jsx